import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyOroro from './components/WhyOroro';
import Services from './components/Services';
import Industries from './components/Industries';
import ResourceCenter from './components/ResourceCenter';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main id="main-content">
        <Hero />
        <WhyOroro />
        <Services />
        <Industries />
        
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App; 